var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockDamage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25V13.035C11.25 14.4375 10.6875 15 9.2775 15H5.715C4.3125 15 3.75 14.4375 3.75 13.035V9.4725C3.75 8.0625 4.3125 7.5 5.715 7.5H7.5V9.2775C7.5 10.6875 8.0625 11.25 9.465 11.25H11.25Z",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.2775V7.5V6C15 4.75736 13.9926 3.75 12.75 3.75H11.25H9.465C8.0625 3.75 7.5 4.3125 7.5 5.715V9.2775C7.5 10.6875 8.0625 11.25 9.465 11.25H13.0275C14.4375 11.25 15 10.6875 15 9.2775Z",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 2.25L2.25 16.125",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockDamage);
export default __webpack_public_path__ + "static/media/stock-damage.2068873e8b6b4b383113048566914d28.svg";
export { ForwardRef as ReactComponent };